import { getRequestParams } from "../utils/CookieHelper";
import { getRequestUrl, getHttpParams } from "../utils/Utils";
import { error, log, onResponse } from "./ApiUtils";
export class PaymentApi {
    
    static getTransactions(onSuccess, onError) {
        fetch(getRequestUrl() + "getTransactions", getHttpParams({})).then((response) => response.json())
        .then((responseData) => {
            onResponse(responseData, onSuccess, onError)
        })
    }
    static addRequestMoney(params, onSuccess, onError) {
        fetch(getRequestUrl() + "addRequestMoney", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            onResponse(responseData, onSuccess, onError)
        })
    }
    static preparePurchase(onSuccess, onError) {
        fetch(getRequestUrl() + "preparePurchase", getHttpParams({})).then((response) => response.json())
        .then((responseData) => {
            onResponse(responseData, onSuccess, onError)
        })
    }
    static getTinkofToken(data, onSuccess, onError) {
        fetch(getRequestUrl() + "getTinkofToken", getHttpParams({data : data})).then((response) => response.json())
        .then((responseData) => {
            log("getTinkofToken = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
    }
    static addCardToClientTinkof(onSuccess, onError) {
        fetch(getRequestUrl() + "addCardToClientTinkof", getHttpParams({})).then((response) => response.json())
        .then((responseData) => {
            log("addCardToClientTinkof = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
    }
    static getCardsPayoutTinkof(onSuccess, onError) {
        fetch(getRequestUrl() + "getCardsPayoutTinkof", getHttpParams({})).then((response) => response.json())
        .then((responseData) => {
            log("getCardsPayoutTinkof = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
    }
    static addSozvonByLinkDelayedConfirmation(pressed_confirm_sozvon_by_link, _id, onSuccess, onError) {
        fetch(getRequestUrl() + "addSozvonByLinkDelayedConfirmation", getHttpParams({pressed_confirm_sozvon_by_link : pressed_confirm_sozvon_by_link, _id : _id})).then((response) => response.json())
        .then((responseData) => {
            log("addSozvonByLinkDelayedConfirmation = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
    }
   
}